import React from 'react'
import { connect } from 'react-redux'


class MessageElement extends React.Component {

  render() {
    const { element } = this.props
    return (
      <div style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: element.label }} />
    )
  }

}

MessageElement.propTypes = {
  element: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(MessageElement)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/FormPage/PageElement/MessageElement/index.jsx